export default __webpack_public_path__ + "static/media/thumbs-up.4cd71cf5.png";